/* =====================================================
   SCROLL-REVEAL.JS — IntersectionObserver animation system
   ===================================================== */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* If reduced motion: show all .reveal elements immediately and skip setup */
  if (reducedMotion) {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('revealed');
    });
    document.querySelectorAll('video[data-lazy]').forEach(function (video) {
      video.removeAttribute('autoplay');
    });
    return;
  }

  /* ── Scroll reveal observer ── */
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
          setTimeout(function () {
            el.classList.add('revealed');
          }, delay);
          revealObserver.unobserve(el);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ── Lazy video observer ── */
  function playVideo(video) {
    /* Load first if nothing is buffered */
    if (video.readyState === 0) {
      video.load();
    }
    /* Try to play — if rejected wait for canplay then retry */
    var promise = video.play();
    if (promise !== undefined) {
      promise.catch(function () {
        video.addEventListener('canplay', function handler() {
          video.removeEventListener('canplay', handler);
          video.play().catch(function () {});
        });
      });
    }
  }

  var videoObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          playVideo(video);
        } else {
          if (!video.paused) video.pause();
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('video[data-lazy]').forEach(function (video) {
    videoObserver.observe(video);
  });
})();
